
import React from 'react';
import { CheckCircle, ClipboardCheck, Wrench, Shield, Award } from 'lucide-react';

const InstallationProcess = () => {
  const steps = [
    {
      icon: <ClipboardCheck className="h-8 w-8 text-brand-safety-orange" />,
      title: "Material Selection & Planning",
      description: "Free consultation to select the best materials for your specific needs and budget",
      details: [
        "Comprehensive roof inspection",
        "Material recommendations based on climate",
        "Detailed project timeline",
        "Transparent pricing with no hidden fees"
      ]
    },
    {
      icon: <Wrench className="h-8 w-8 text-brand-safety-orange" />,
      title: "Professional Installation",
      description: "Expert installation by certified technicians following manufacturer specifications",
      details: [
        "Proper substrate preparation",
        "Manufacturer-approved installation methods",
        "Quality control inspections",
        "Clean-up and debris removal"
      ]
    },
    {
      icon: <Shield className="h-8 w-8 text-brand-safety-orange" />,
      title: "Quality Assurance",
      description: "Comprehensive final inspection and warranty registration",
      details: [
        "Multi-point quality inspection",
        "Manufacturer warranty registration",
        "Workmanship guarantee documentation",
        "Maintenance recommendations"
      ]
    },
    {
      icon: <Award className="h-8 w-8 text-brand-safety-orange" />,
      title: "Ongoing Support",
      description: "Continued service and maintenance support for your new roof",
      details: [
        "Annual maintenance programs",
        "Storm damage assessments",
        "Warranty claim assistance",
        "Emergency repair services"
      ]
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl font-bold mb-4">Our Installation Process</h2>
          <p className="text-lg text-gray-600">
            From initial consultation to final inspection, we ensure every installation 
            meets the highest standards of quality and craftsmanship.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow">
                <div className="flex justify-center mb-4">
                  {step.icon}
                </div>
                <h3 className="text-xl font-semibold mb-3 text-center">{step.title}</h3>
                <p className="text-gray-600 mb-4 text-center">{step.description}</p>
                <ul className="space-y-2">
                  {step.details.map((detail, idx) => (
                    <li key={idx} className="flex items-start text-sm">
                      <CheckCircle className="h-4 w-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                      {detail}
                    </li>
                  ))}
                </ul>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 w-8 h-0.5 bg-brand-safety-orange"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InstallationProcess;
